exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe {\n    border: none;\n    height: 380px;\n}\n\n.p-loader {\n    border: 2px solid #d6d5d5;\n    border-top: 2px solid #8BC34A;\n    border-radius: 50%;\n    width: 55px;\n    height: 55px;\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n    position: absolute;\n    top: 48%;\n    left: 46%;\n    z-index: 67;\n}\n\n.disable {\n    pointer-events: none;\n}\n\n.background-shape-inner {\n    border-radius: 50% / 5%;\n}\n\n.background-shape-inner::before {\n    top: 4.5%;\n    bottom: 4.5%;\n    border-radius: 5% / 50%;\n}\n\n.background-shape-outer {\n    border-radius: 50% / 5%;\n}\n\n.background-shape-outer::before {\n    top: 4.5%;\n    bottom: 4.5%;\n    border-radius: 5% / 50%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/css/payment.component.css
// module id = ../../../../../src/app/css/payment.component.css
// module chunks = main